import { useCallback, useMemo, useState } from 'react';
import useImageWithFallback, {
  type ImageMap
} from '~/hooks/common/ui/useImageWithFallback';

type ImageType = 'still';

type WhyBuyStillImage = {
  isFailed: boolean;
  url?: string;
};

export default function useWhyBuyStillImage(
  imageUrl: string | undefined,
  location: string
): WhyBuyStillImage {
  const [failedUrl, setFailedUrl] = useState<string>();
  const images = useMemo<ImageMap<ImageType> | undefined>(
    () =>
      imageUrl ? { still: { imageType: 'still', url: imageUrl } } : undefined,
    [imageUrl]
  );
  const handleFailure = useCallback(() => setFailedUrl(imageUrl), [imageUrl]);
  const loadedImage = useImageWithFallback(
    images,
    imageUrl ? 'still' : undefined,
    location,
    handleFailure
  );

  return {
    isFailed: Boolean(imageUrl) && failedUrl === imageUrl,
    url: loadedImage?.url
  };
}
